import type { NewsArticleCardProps } from "./types";

import { Card, Heading, Paragraph } from "@digdir/designsystemet-react";

export type { NewsArticleCardProps };

export const NewsArticleCard = ({
  url,
  heading,
  introText,
  imageUrl,
  imgAltText,
}: NewsArticleCardProps) => {
  return (
    <Card
      key={`${heading}-${url}`}
      className="flex flex-col items-center rounded-none sm:flex-row lg:flex-col"
    >
      <Card.Block className="w-full h-fit">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={imgAltText}
            className="w-full aspect-video object-cover sm:h-full sm:aspect-[4/3] lg:aspect-video"
          />
        ) : (
          <img
            src="/assets/svg/logo-color.svg"
            alt={heading}
            className="w-full aspect-video object-fill px-4 sm:h-full sm:aspect-[4/3] lg:aspect-video"
          />
        )}
      </Card.Block>
      <Card.Block className="flex flex-col w-full gap-[7px] py-4 px-3 sm:basis-full md:py-5 lg:h-48">
        <Heading className="heading-sm mb-0 pb-0.5 text-neutralNsf line-clamp-2">
          <a
            href={url}
            rel="noopener noreferrer"
            className="decoration-from-font xl:decoration-2"
          >
            {heading}
          </a>
        </Heading>
        <Paragraph className="!mb-0 text-md text-neutralNsf line-clamp-5 sm:line-clamp-3 md:line-clamp-4">
          {introText}
        </Paragraph>
      </Card.Block>
    </Card>
  );
};
